import React, { useRef } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components

import CloudUpload from "@material-ui/icons/CloudUpload";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import Card from "components/UI/Card/Card.js";
import CardBody from "components/UI/Card/CardBody.js";
import CardHeader from "components/UI/Card/CardHeader.js";
import CardIcon from "components/UI/Card/CardIcon.js";
import GridContainer from "components/UI/Grid/GridContainer.js";
import ReactTable from "components/Tables/ReactTable/ReactTable.js";
import { useEffect } from "react";

import { CircularProgress, Tooltip } from "@material-ui/core";
import { ArrowFatDown, Eye } from "@phosphor-icons/react";
import Badge from "components/UI/Badge/Badge";
import ButtonTS from "components/Forms/CustomButtons/ButtonTS";
import GridItemTS from "components/UI/Grid/GridItemTS";
import LoadingModal from "components/Modals/LoadingModal/LoadingModal";
import * as dateFns from "date-fns";
import { Parser } from "json2csv";
import { useTranslation } from "react-i18next";
import LoadingBar from "react-top-loading-bar";
import apiInputService from "services/apiInputService";
import { useFilesSubmittedForBulkUpload } from "services/input-core/external-data/get-files-submitted";
import UploadModal from "./UploadModal";
import ViewSensitiveDataModal from "./ViewSensitiveDataModal";
import { toast } from "react-toastify";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const stylesAny: any = styles;
const useStyles = makeStyles(stylesAny);

const CargaMassiva: React.FC = () => {
  const loadingBarRef = useRef(null);
  const { t, i18n } = useTranslation("bulk-upload");
  const classes = useStyles();

  const [processFormatted, setProcessFormatted] = React.useState([]);
  const [currentProcessId, setCurrentProcessId] = React.useState("");

  const { data, refetch } = useFilesSubmittedForBulkUpload({
    staleTime: 0,
    cacheTime: 30 * 1000, // 30 seconds
    refetchOnWindowFocus: true,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSuccess: (data: any) => {
      formatTable(data);
    },
  });

  const [openLoadingModal] = React.useState(false);

  const [uploadModal, setUploadModal] = React.useState(false);
  const [viewModal, setViewModal] = React.useState(false);

  useEffect(() => {
    formatTable(data);
  }, [i18n.language]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function formatTable(data: any) {
    const formatted =
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      data?.map((item: any) => ({
        uploadedDataCount: item.qttyRecordsUploaded,
        status: generateStatus(item.processed),
        submittedBy: item.user.email,
        createdAt: dateFns.format(
          new Date(item.createdAt),
          "dd/MM/yyyy HH:mm:ss",
        ),
        updatedAt: dateFns.format(
          new Date(item.updatedAt),
          "dd/MM/yyyy HH:mm:ss",
        ),
        actions: (
          <div className="actions-right">
            <Tooltip title="Ver detalle">
              <ButtonTS
                justIcon
                round
                color="info"
                onClick={() => {
                  setCurrentProcessId(item._id);
                  setViewModal(true);
                }}
                disabled={!item.processed}
              >
                <Eye weight="bold" size={20} />
              </ButtonTS>
            </Tooltip>
          </div>
        ),
      })) || [];

    setProcessFormatted(formatted.reverse());
  }

  function downloadCSV(csv: BlobPart) {
    const blob = new Blob([csv]);
    // eslint-disable-next-line no-undef
    const url = window.URL.createObjectURL(blob);
    // eslint-disable-next-line no-undef
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `workers.csv`);
    // eslint-disable-next-line no-undef
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) link.parentNode.removeChild(link);
  }

  function convertJsonToCSV(json: unknown[]) {
    const json2csvParser = new Parser({
      quote: "",
      delimiter: ",",
      eol: "\r\n",
    });
    const csv = json2csvParser.parse(json);
    return csv;
  }

  function SubmitGetAll() {
    loadingBarRef.current.continuousStart();
    apiInputService({
      method: "get",
      url: `/ExternalData/internalFields/all`,
    })
      .then((response) => {
        const workers = response.data;
        if (workers.length === 0) {
          toast.info("No tiene datos para mostrar.");
          return;
        }
        downloadCSV(convertJsonToCSV(workers));
        loadingBarRef?.current?.complete();
      })
      .catch(() => {
        toast.error("Fallo al obtener los datos sensibles.");
      });
  }

  const generateStatus = (processed: boolean) => {
    return processed ? (
      <Badge color="success">{t("finished")}</Badge>
    ) : (
      <Badge color="warning">
        {t("processing")}{" "}
        <CircularProgress
          size="10px"
          color="secondary"
          style={{ marginLeft: "4px" }}
        />
      </Badge>
    );
  };

  return (
    <>
      <LoadingBar color="#ff9800" ref={loadingBarRef} />
      <LoadingModal open={openLoadingModal} />

      <GridContainer>
        <GridItemTS xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <CloudUpload />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("bulk-upload")}</h4>
            </CardHeader>
            <CardBody>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  borderBottom: "1px solid #C4C4C4",
                }}
              >
                <h4 className={classes.cardIconTitle}>
                  {t("files-submitted")}
                </h4>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <ButtonTS
                    variant="outline"
                    simple
                    color="primary"
                    onClick={() => SubmitGetAll()}
                  >
                    <ArrowFatDown size="24px" weight="fill" />
                    {t("actions.download-template")}
                  </ButtonTS>
                  <ButtonTS
                    color="primary"
                    onClick={() => {
                      setUploadModal(true);
                    }}
                  >
                    {t("actions.upload-csv")}
                  </ButtonTS>
                </div>
              </div>

              <ReactTable
                initialPageSize={5}
                columns={[
                  {
                    Header: t("upload-modal.header.data-submitted-count"),
                    accessor: "uploadedDataCount",
                  },
                  {
                    Header: t("upload-modal.header.status"),
                    accessor: "status",
                  },
                  {
                    Header: t("upload-modal.header.submittedBy"),
                    accessor: "submittedBy",
                  },
                  {
                    Header: t("upload-modal.header.createdAt"),
                    accessor: "createdAt",
                  },
                  {
                    Header: t("upload-modal.header.updatedAt"),
                    accessor: "updatedAt",
                  },
                  {
                    Header: t("upload-modal.header.actions"),
                    accessor: "actions",
                    width: 0,
                  },
                ]}
                data={processFormatted || []}
              />
            </CardBody>
          </Card>
        </GridItemTS>
        <UploadModal
          open={uploadModal}
          onClose={() => {
            refetch();
            setUploadModal(false);
          }}
          onSuccess={() => {
            toast.success(t("notifications.file-sent-to-process"));
          }}
          onFail={() => {
            toast.error(t("notifications.file-sent-to-process-error"));
          }}
        />
        <ViewSensitiveDataModal
          processId={currentProcessId}
          open={viewModal}
          onClose={() => {
            setViewModal(false);
          }}
        />
      </GridContainer>
    </>
  );
};

export default CargaMassiva;
